import { useState } from 'react'
import { Container, Card, Col, Row, Button, FloatingLabel, Form } from 'react-bootstrap';
import toast from 'react-hot-toast';
import { useLocation, useNavigate } from 'react-router-dom';
import home_logo from '../../assets/icons/ICRI_NEW1.png';
import Auth from '../../auth/auth';
import MockService from '../../Services/MockService';

interface IVerifyEmail {
    email: string
}

export default function VerifyEmail() {
    const state = useLocation().state as IVerifyEmail;
    const email = state?.email || '';
    const navigate = useNavigate();

    const [otp, setOtp] = useState('');
    const [loading, setLoading] = useState(false);

    const handleVerify = async () => {
        if (!otp) {
            toast.error('Please enter the OTP');
            return;
        }
        setLoading(true);
        await MockService.mockEmailVerify(email, otp)
            .then(async (res) => {
                if (res.status === 200) {
                    localStorage.setItem('authKey', res.data?.data?.token || '');
                    Auth.authenticate();
                    toast.success('Verified successfully');
                    navigate('/student-info');
                }
            })
            .catch((err) => {
                console.error(err);
                toast.error('Invalid OTP. Please try again.');
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <div style={{ height: '100vh', backgroundColor: '#eeeeee' }}>
            <Container style={{ maxWidth: '400px' }}>
                <div className="d-flex justify-content-center align-items-center flex-column">
                    <h1 className="text-center font-weight-bold xcn-login-header pt-3">
                        <img src={home_logo} height="70px" />
                    </h1>
                    <h3 className="text-center font-weight-bold">Verify your Email</h3>
                    <p className="text-center mt-2">
                        Enter the OTP sent to <strong>{email}</strong>
                    </p>
                </div>

                <Row className="justify-content-md-center mt-4">
                    <Col md="12">
                        <Card className="p-4 border-0 shadow">
                            <FloatingLabel controlId="floatingOtp" label="Enter OTP" className="mb-3">
                                <Form.Control
                                    type="text"
                                    placeholder="OTP"
                                    value={otp}
                                    onChange={(e) => setOtp(e.target.value)}
                                    maxLength={6}
                                />
                            </FloatingLabel>

                            <Button
                                variant="primary"
                                className="mt-2"
                                size="lg"
                                onClick={handleVerify}
                                disabled={loading}
                            >
                                <span className="xcn-text-14">
                                    {loading ? 'Verifying...' : 'Verify'}
                                </span>
                            </Button>

                            <Button
                                variant="link"
                                className="mt-2 text-muted"
                                size="sm"
                                onClick={() => navigate('/login')}
                            >
                                Back to Login
                            </Button>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}
